import { useRef } from 'react';
import { PortableText, PortableTextProps } from '@portabletext/react';
import clsx from 'clsx';
import useAddAccessibility from 'shared/hooks/addAccessibility';
import { serializers } from './Serializers/Serializers';
import styles from './PortableText.module.scss';

interface CustomPortableTextProps extends PortableTextProps {
  className?: string;
  id?: string;
  addAccessibility?: boolean;
  tag?: 'normal' | 'blockquote' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const CustomPortableText: React.FC<CustomPortableTextProps> = ({
  className,
  id,
  addAccessibility,
  // 'normal' is the default value and it renders a <p>
  tag: style = 'normal',
  ...props
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useAddAccessibility(contentRef, !!addAccessibility);

  const value = Array.isArray(props.value)
    ? props.value.map((block) =>
        block._type === 'block'
          ? {
              ...block,
              style
            }
          : block
      )
    : [
        {
          _type: 'block',
          style,
          markDefs: [],
          children: [
            {
              _type: 'span',
              marks: [],
              text: props.value,
              _key: 'generated-key'
            }
          ]
        }
      ];

  return (
    <div className={clsx(className, styles.portable)} id={id} ref={contentRef}>
      <PortableText {...props} value={value} components={serializers} />
    </div>
  );
};

export default CustomPortableText;
